import { useEffect, useState } from "react";

const usePort = () => {
    const [project, setproject] = useState([])
    useEffect(() => {
        fetch('port.json').then(res => res.json()).then(data => setproject(data))
    }, [])
    return [project]
}
export default usePort;